/**
 * Appointman Tiny WebApp
 * @author Dennis Schnelle
 *
 *
 */

import AppointmanApp from './App';
import config from './config';
import 'core-js/es6/promise';

declare global {
    interface Window {
        vf: any;
        google: any;
        jQuery: any;
        $: any;

    }
}

(function() {
    'use strict';

    // using global vf var to make the app accessible in other components if necessarily
    window.vf = window.vf || {};

    window.vf.appointman = {
        init: () => {
            new AppointmanApp(
                <HTMLElement> $(config.appointman.selectors.appContainer).get(0)
            );
        }
    };

    $(() => {
        window.vf.appointman.init();
    });
}());



// WEBPACK FOOTER //
// ./app/bundles/appointman/app/ts/appointman.ts